module.exports = __webpack_public_path__ + "img/Pygmy_demo.56bc5695.gif";